var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('canvas',{staticClass:"w-100 bg-secondary"},[_c('p',[_vm._v("Your browser does not support the HTML5 canvas tag.")])])
}]

export { render, staticRenderFns }